import { render, staticRenderFns } from "./recycleNewOrder.vue?vue&type=template&id=1097fdd2&scoped=true&"
import script from "./recycleNewOrder.vue?vue&type=script&lang=js&"
export * from "./recycleNewOrder.vue?vue&type=script&lang=js&"
import style0 from "./recycleNewOrder.vue?vue&type=style&index=0&id=1097fdd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1097fdd2",
  null
  
)

export default component.exports